import { ModuleID } from '../types'
import { IImagesModule } from './types'

import ImageAsset from './ImageAsset'
// import filterTarget from '@aytm/app/swidget/base/modules/images/filterTarget'
// import { SyntheticEvent } from 'react'

let moduleLoaded = false
const ImagesModule: IImagesModule = {
  get id() {
    return ModuleID.IMAGES
  },
  config(_props) {
    return ImagesModule
  },
  async load() {
    moduleLoaded = true
    return Promise.resolve(ImagesModule)
  },
  get loaded() {
    return moduleLoaded
  },
  get ImageAsset() {
    return ImageAsset
  }
  // ,
  // filterTarget(event: SyntheticEvent) {
  //   return filterTarget(event)
  // }
}

export default ImagesModule
